const emptyFilter = {
  genders: [],
  distanceUnit: 'MILES',
  distanceValue: null,
  postalCode: '',
  ethnicities: [],
  gradeLevels: [],
  gpaScores: [],
  name: '',
  visible: true,
};

export default emptyFilter;
